import img from '../../assets/price1.svg'
import { Circle } from 'rc-progress';
import { useState } from 'react';
import ideas from '../../assets/developers/ideas.png'
import brain from '../../assets/developers/brain.png'
import catchUp from '../../assets/developers/catchUp.png'
import dream from '../../assets/developers/dream.png'
import match from '../../assets/developers/match.png'
import DialogBox from '../Dialog/Dialog';
import { useNavigate } from 'react-router-dom';


const HowTo = ({ data, portfolioData }) => {

    const [open, setopen] = useState(false)
    const [percent, setpercent] = useState(50)
    const navigate = useNavigate()

    const [isHover, setisHover] = useState('')

    const cardsData = [
        {
            title: 'We Catch-up',
            img: catchUp,
            color: 'bg-red-500',
            roundColor: 'rgb(239 68 68)',
            percent: 20,
            textColor: 'text-red-500'
        },
        {
            title: 'You amaze us with your ideas',
            img: ideas,
            color: 'bg-orange-500',
            roundColor: 'rgb(249 115 22 )',
            percent: 40,
            textColor: 'text-orange-500'
        },
        {
            title: 'Oh yes, we matched!',
            img: match,
            color: 'bg-cyan-500',
            roundColor: 'rgb(6 182 212)',
            percent: 60,
            textColor: 'text-cyan-600'

        },
        {
            title: 'Some brainstorming',
            img: brain,
            color: 'bg-blue-500',
            roundColor: 'rgb(59 130 246)',
            percent: 80,
            textColor: 'text-blue-600'

        },
        {
            title: 'Viola! You have your dream team',
            img: dream,
            color: 'bg-purple-500',
            roundColor: 'rgb(34 197 94)',
            percent: 100,
            textColor: 'text-green-600'

        },
    ]

    const handleClick = (index) => {

        if (index === 0 || index === 3) {
            setopen(true)
        }
        else if (index === 1 || index === 2) {
            navigate('/contact-us')
        }
        else if (index === 4) {
            navigate('/pricing')
        }
    }


    const handlePercentage = (value) => {

        setisHover(value)
        setpercent(0)
        setTimeout(() => {
            setpercent(value)
        }, 400);

    }

    const handlePercentOut = () => {
        setpercent(0)
        setisHover('')
    }

    return (
        <div className='max-w-screen-2xl mx-auto py-5 md:py-8 px-2 md:px-10'>

            <DialogBox open={open} setOpen={setopen} />
            {portfolioData ? (
                <div>
                    <h1
                        className='text-xl dark:text-white md:text-2xl font-bold text-center'
                    >
                        {portfolioData.title1} <span className='text-red-500'>{portfolioData.title2}</span>
                    </h1>
                    <p className='text-center text-[15px] md:text-xs my-2 mx-auto md:max-w-[700px] dark:text-white'>
                        {portfolioData.desc}
                    </p>
                </div>
            ) : (
                <div>
                    <h1
                        className='text-xl dark:text-white md:text-2xl font-bold text-center'
                    >
                        How to hire {data.title} <span className='text-red-500'><br />with CodeZone?</span>
                    </h1>
                    <p className='text-center text-[15px] my-2 mx-auto md:max-w-[700px] dark:text-white'>
                        {data.desc}
                    </p>
                </div>
            )}

            <div className='my-7 md:my-16 flex justify-center flex-wrap gap-4 lg:gap-0 mx-auto'>
                {cardsData.map((item, i) => (
                    <div className='flex' key={i}>
                        <div className='w-[120px] md:w-[160px] '>
                            <div className='relative hover:scale-105 group duration-700 cursor-pointer' onClick={() => handleClick(i)} onMouseEnter={() => handlePercentage(item.percent)} onMouseLeave={() => handlePercentOut()}>
                                <div className='absolute inset-0 flex items-center justify-center' >
                                    <div className='h-[110px] relative md:h-[160px] w-[110px] md:w-[160px] p-2.5 flex rounded-full bg-white shadow-md '>
                                        <div className='flex justify-center items-center bg-[#f2f7fb] shadow-lg h-full w-full rounded-full'>

                                            {isHover === item.percent && (
                                                <div className='absolute z-30 inset-0 rounded-full p-2.5'>
                                                    <div className='group-hover:bg-gray-300 transition-all opacity-60 duration-700 h-full w-full rounded-full '>
                                                        <div className='flex justify-center h-full items-center'>
                                                            <h1 className={`${item.textColor} text-xl font-bold`}>
                                                                {isHover}%
                                                            </h1>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            <img src={item.img} alt="img" className='h-[30px] md:h-[60px]' />

                                        </div>
                                    </div>
                                </div>
                                <Circle
                                    percent={isHover === item.percent ? percent : item.percent}
                                    strokeWidth={3.5}
                                    strokeColor={item.roundColor}
                                    className='h-[120px] md:h-[160px] '
                                    trailColor='transparent'

                                    style={{ transform: 'rotate(0deg)' }}
                                />
                            </div>
                            <div>
                                <p className='mt-3 font-bold text-[14px] md:text-xs text-center dark:text-white'>
                                    {item.title}
                                </p>
                            </div>
                        </div>
                        {i < 4 && (

                            <div className='h-[150px] hidden lg:flex items-center'>
                                <div className={`h-[7px] w-[50px] ${item.color}`} />
                            </div>
                        )}
                    </div>
                ))}
            </div>



        </div>
    )
}

export default HowTo